// Imports Angular
import { BrowserModule } from '@angular/platform-browser';
import { NgModule, Compiler } from '@angular/core';
import { Http, HttpModule } from '@angular/http';
import { FormsModule } from '@angular/forms';
import { BrowserAnimationsModule, NoopAnimationsModule } from '@angular/platform-browser/animations';

// External Modules
import { FlexLayoutModule } from '@angular/flex-layout';
import { MaterialModule } from './resources/configuracion/material.module';
import { SessionStorageService } from 'ngx-webstorage';
import { Ng2Webstorage } from 'ngx-webstorage';
import { CookieService } from 'angular2-cookie/services/cookies.service';
import { Logger } from 'angular2-logger/core';

// Components view
import { AppComponent } from './app.component';
//import { LoginComponent } from './components/login/login.component';
import { DNotificacionesComponente } from '@dian-cmp/notificaciones';
import { DNotificacionServicio } from '@dian-cmp/notificaciones';
import { DIdentidadAuthConfigServicios } from '@dian/api-identidad-auth-config';

// Libs framework
import { DLogger } from '@dian/core';
import { DLoggerAngular } from '@dian/core';
import { DContextoMuiscaServicio } from '@dian/core';
import { DContextoMuiscaDesaServicio } from '@dian/core';
import { DSessionStorage } from '@dian/core';
import { DFormularioServicio } from '@dian/api-formulario';

// Conf
import { loggerFactory, contextoMuiscaFactory, formularioFactory, sessionStorageFactory } from './resources/configuracion/app.factories';
import { AppRoutingModule } from './app-routing.module';
//import { HabilitarComponent } from './components/habilitar/habilitar.component';

//Modules
import { LoginModule } from './modules/login/login.module';
import { HabilitarCuentaModule } from './modules/habilitar-cuenta/habilitar-cuenta.module';
import { RecuperarPassModule } from './modules/recuperar-pass/recuperar-pass.module';


@NgModule({
  declarations: [
    AppComponent,
    DNotificacionesComponente   
    //LoginComponent, 
    //HabilitarComponent     
  ],
  imports: [
    //Angular
    BrowserModule,
    //HttpModule, 
    //FormsModule,
    BrowserAnimationsModule,
    NoopAnimationsModule,
    //External
    /*Ng2Webstorage.forRoot({ 
      prefix: 'DIAN', 
      separator: '-', 
      caseSensitive:true 
    }),*/
    //Material
    FlexLayoutModule,
    MaterialModule,
    //Aplicacion
    AppRoutingModule,    
    LoginModule,
    HabilitarCuentaModule,
    RecuperarPassModule
  ],
  providers: [   
    /*CookieService, 
    Compiler,
    Logger,
    DNotificacionServicio,
    DIdentidadAuthConfigServicios,
    {
        provide: DLogger,
        useFactory: loggerFactory,
        deps: [Logger]
    },
    {
        provide: DSessionStorage,
        useFactory: sessionStorageFactory,
        deps: [SessionStorageService,DLogger]
    },
    {
        provide: DContextoMuiscaServicio,
        useFactory: contextoMuiscaFactory,
        deps: [Http, CookieService, Compiler, DLogger, DNotificacionServicio, DSessionStorage]
    },
    {
        provide:  DFormularioServicio,
        useFactory: formularioFactory,
        deps: [DContextoMuiscaServicio]            
    }    */
  ],
  bootstrap: [
    AppComponent
  ],
  entryComponents: [
    DNotificacionesComponente    
  ]
})
export class AppModule { }



// WEBPACK FOOTER //
// C:/Users/whuerfanoh/Documents/VSCode Projects/ng_identidadlogin/webapp/src/app/app.module.ts